import type { Translation } from '../../types';
import type { accounts as en } from '../en/accounts';

export const accounts: Translation<typeof en> = {
  crumb: 'Kinh doanh',
  tierReseller: 'hạng đại lý',
  filter: {
    any: 'Tất cả',
    search: 'Tìm kiếm',
    status: 'Trạng thái',
    type: 'Loại',
    clearFilter: 'Bỏ bộ lọc: {{label}}',
    customer: 'Khách hàng: {{name}}',
    subject: 'Chủ thể: {{name}}',
    owner: 'Thuộc về: {{name}}',
    selectedRecord: 'bản ghi đã chọn',
  },
  pager: { shown: 'Đang hiển thị {{count}}' },
  common: {
    none: 'Không có',
    never: 'Chưa từng',
    yes: 'Có',
    no: 'Không',
    masked: 'Đã che',
    maskedHint: 'Dữ liệu cá nhân đã được che: chỉ lưu gợi ý để hiển thị',
    hiddenName: 'Tên được ẩn',
    notFound: 'Không tìm thấy',
    created: 'Ngày tạo',
    updated: 'Cập nhật',
    country: 'Quốc gia',
    currency: 'Tiền tệ',
    tier: 'Hạng',
    status: 'Trạng thái',
    type: 'Loại',
    id: 'ID',
    domains: 'Tên miền',
    customers: 'Khách hàng',
    subjects: 'Chủ thể',
    documents: 'Giấy tờ',
    version: 'Phiên bản',
    versionN: 'v{{n}}',
    expires: 'Hết hạn',
    overview: 'Tổng quan',
    showAll: 'Xem tất cả',
    firstN: '{{count}} bản ghi đầu',
    newestN: '{{count}} bản ghi mới nhất',
    noPermission: 'Vai trò của bạn không được xem dữ liệu thanh toán của tài khoản này.',
  },
  customers: {
    title: 'Khách hàng',
    subtitle: 'Các tài khoản đặt mua và thanh toán tên miền. Chủ thể đăng ký của từng tên miền được quản lý riêng trong mục Chủ thể.',
    searchPlaceholder: 'Tên, e-mail chính xác hoặc ID',
    loadError: 'Không tải được danh sách khách hàng',
    empty: 'Không có khách hàng phù hợp',
    col: { customer: 'Khách hàng', typeCountry: 'Loại · quốc gia', status: 'Trạng thái', domains: 'Tên miền', subjects: 'Chủ thể', currency: 'Tiền tệ', created: 'Ngày tạo' },
  },
  customer: {
    fallbackTitle: 'Khách hàng',
    loading: 'Đang tải khách hàng…',
    notFound: 'Không tìm thấy khách hàng',
    loadError: 'Không tải được khách hàng',
    account: 'Tài khoản',
    maskedNote: 'E-mail và số điện thoại đã được che. Đây là tài khoản thanh toán; chủ thể đăng ký của từng tên miền nằm ở thẻ Chủ thể.',
    profile: {
      title: 'Thông tin thanh toán',
      language: 'Ngôn ngữ thông báo',
      languageByCountry: 'Theo quốc gia',
      invoiceSource: 'Thông tin xuất hoá đơn',
      invoiceSame: 'Giống chủ thể chính',
      invoiceOwn: 'Thông tin riêng',
    },
    primary: {
      title: 'Chủ thể chính',
      hint: 'Thông tin định danh (họ tên, giấy tờ, ngày sinh, địa chỉ, người đại diện) sửa ở chủ thể; mỗi lần sửa tạo phiên bản mới.',
      none: 'Chưa có chủ thể chính',
      noneHint: 'Khách hàng này chưa gắn chủ thể đứng tên tài khoản. Tạo mới hoặc chọn một chủ thể của khách hàng.',
      create: 'Tạo chủ thể chính',
      createTitle: 'Tạo chủ thể chính',
      createdReason: 'chủ thể chính tạo từ trang khách hàng',
      pick: 'Hoặc chọn chủ thể có sẵn',
      reason: 'Lý do',
      link: 'Đặt làm chủ thể chính',
      edit: 'Sửa chủ thể',
      unverified: 'Chưa xác minh',
      representative: 'Người đại diện',
      badge: 'Chủ thể chính',
    },
    field: {
      code: 'Mã khách hàng',
      email: 'E-mail',
      phone: 'Điện thoại',
      billingCurrency: 'Tiền tệ thanh toán',
    },
    stat: { domains: 'Tên miền', subjects: 'Chủ thể quản lý', users: 'Người dùng', wallet: 'Số dư ví', walletHint: 'khả dụng · {{held}} đang tạm giữ', noWallet: 'Chưa có ví', openWallet: 'Xem ví' },
    tab: { domains: 'Tên miền ({{count}})', subjects: 'Chủ thể ({{count}})', users: 'Người dùng ({{count}})', billing: 'Thanh toán' },
    menu: {
      title: 'Thao tác',
      edit: 'Sửa thông tin',
      addUser: 'Thêm người dùng',
      register: 'Đăng ký tên miền',
      newSubject: 'Tạo chủ thể',
      related: 'Liên quan',
      orders: 'Tất cả đơn hàng',
      subjects: 'Tất cả chủ thể',
      wallet: 'Ví',
      webhooks: 'Webhook của khách',
      apiKeys: 'Khoá API',
    },
    noUsers: 'Chưa có người dùng liên kết',
    userCol: { name: 'Họ tên', relation: 'Vai trò trong tài khoản', kind: 'Loại', status: 'Trạng thái', lastLogin: 'Đăng nhập gần nhất', linked: 'Liên kết từ' },
    noSubjects: 'Tài khoản này không quản lý chủ thể nào',
    subjectCol: { legalName: 'Tên pháp lý', type: 'Loại', status: 'Trạng thái', verification: 'Xác minh', domains: 'Tên miền', country: 'Quốc gia', created: 'Ngày tạo' },
    noDomains: 'Chưa có tên miền',
    servicesTab: 'Dịch vụ ({{count}})',
    noServices: 'Chưa có dịch vụ',
    servicesMore: '{{count}} dịch vụ đầu tiên: xem đủ ở Bán hàng & tài chính › Dịch vụ.',
    serviceCol: { service: 'Dịch vụ', plan: 'Sản phẩm / gói', state: 'Trạng thái', due: 'Đã trả đến', amount: 'Giá mỗi chu kỳ' },
    domainCol: { domain: 'Tên miền', registrant: 'Chủ thể', registry: 'Registry', lifecycle: 'Vòng đời', dossier: 'Hồ sơ', expiry: 'Hết hạn tại registry' },
    billing: {
      loading: 'Đang tải dữ liệu thanh toán…',
      loadError: 'Không tải được dữ liệu thanh toán',
      wallets: 'Ví',
      noWallets: 'Tài khoản này chưa có ví.',
      wallet: 'Ví {{currency}}',
      walletCol: { wallet: 'Ví', status: 'Trạng thái', balance: 'Số dư', held: 'Tạm giữ', available: 'Khả dụng' },
      orders: 'Đơn hàng ({{count}})',
      noOrders: 'Chưa có đơn hàng',
      orderCol: { order: 'Đơn hàng', status: 'Trạng thái', items: 'Số mục', total: 'Tổng tiền' },
      invoices: 'Hoá đơn ({{count}})',
      noInvoices: 'Chưa có hoá đơn',
      invoiceCol: { number: 'Số hoá đơn', type: 'Loại', total: 'Tổng tiền', order: 'Đơn hàng', issued: 'Ngày phát hành' },
      payments: 'Thanh toán ({{count}})',
      noPayments: 'Chưa có giao dịch thanh toán',
      paymentCol: { payment: 'Số tiền', purpose: 'Mục đích', provider: 'Cổng thanh toán', status: 'Trạng thái', created: 'Ngày tạo' },
      invoiced: 'Đã xuất hoá đơn (ròng)',
      viewAll: 'Xem tất cả',
    },
  },
  user: {
    fallbackTitle: 'Người dùng',
    subtitle: 'Đăng nhập thay mặt {{account}}',
    thisAccount: 'tài khoản đang xem',
    loading: 'Đang tải người dùng…',
    notFound: 'Người dùng này không liên kết với tài khoản',
    loadError: 'Không tải được người dùng',
    profile: 'Hồ sơ người dùng',
    field: {
      account: 'Tài khoản khách hàng',
      email: 'E-mail',
      kind: 'Loại',
      relation: 'Vai trò trong tài khoản này',
      linked: 'Liên kết với tài khoản từ',
      mfa: 'Xác thực hai lớp',
      locked: 'Bị khoá',
      lastLogin: 'Đăng nhập gần nhất',
      sessions: 'Phiên đang hoạt động',
    },
    mfa: { enrolled: 'Đã kích hoạt', required: 'Bắt buộc, chưa kích hoạt', optional: 'Không bắt buộc' },
    maskedNote: 'Địa chỉ e-mail đã được che. Lịch sử đăng nhập được lưu trong nhật ký kiểm toán.',
    accounts: 'Các tài khoản người dùng này được thao tác ({{count}})',
    accountCol: { customer: 'Khách hàng', type: 'Loại', status: 'Trạng thái', relation: 'Vai trò trong tài khoản', linked: 'Liên kết từ' },
    roles: 'Vai trò ({{count}})',
    noRoles: 'Chưa được cấp vai trò nào',
    roleCol: { role: 'Vai trò', scope: 'Áp dụng cho', granted: 'Cấp lúc', grantedBy: 'Người cấp', revoked: 'Hiệu lực' },
    revokedOn: 'Thu hồi ngày {{date}}',
    scopeGlobal: 'Toàn hệ thống',
    scopeHidden: 'Ngoài phạm vi quyền của bạn',
    active: 'Đang hiệu lực',
  },
  subjects: {
    title: 'Chủ thể',
    subtitle: 'Chủ thể đăng ký (cá nhân và tổ chức) đứng tên các tên miền, kèm tình trạng xác minh hiện tại.',
    searchPlaceholder: 'Tên pháp lý hoặc ID chủ thể',
    loadError: 'Không tải được danh sách chủ thể',
    empty: 'Không có chủ thể phù hợp',
    noVersion: '(chưa có phiên bản hiện hành)',
    versionN: 'v{{n}}',
    piiNote: 'Số giấy tờ định danh không bao giờ hiển thị trong danh sách. Mở từng chủ thể để xem gợi ý đã che; việc xem số đầy đủ được ghi vào nhật ký kiểm toán.',
    col: { legalName: 'Tên pháp lý', typeCountry: 'Loại · quốc gia', status: 'Trạng thái', verification: 'Xác minh', managedBy: 'Quản lý bởi', domains: 'Tên miền', created: 'Ngày tạo' },
  },
  customerActions: {
    edit: 'Sửa thông tin khách hàng',
    editTitle: 'Sửa thông tin khách hàng',
    editDescription: 'Thay đổi được ghi nhật ký kiểm toán cùng lý do. E-mail, điện thoại, địa chỉ và số định danh chỉ ghi nhận là "đã đổi", không lưu giá trị.',
    email: 'E-mail liên hệ',
    phone: 'Điện thoại liên hệ',
    identityOnSubject: 'Họ tên, giấy tờ, địa chỉ và người đại diện là thông tin của chủ thể chính: sửa ở trang chủ thể. Ở đây chỉ sửa tài khoản và thông tin xuất hoá đơn.',
    currency: 'Tiền tệ thanh toán',
    currencyLocked: 'Đã có phát sinh sổ cái, đơn hàng hoặc thanh toán nên không đổi được tiền tệ.',
    tier: 'Hạng',
    status: 'Trạng thái',
    statusHint: 'Tạm ngưng hoặc đóng tài khoản cần nêu rõ lý do.',
    save: 'Lưu thay đổi',
    saved: 'Đã lưu thông tin khách hàng.',
    noChange: 'Không có gì thay đổi.',
    addUser: 'Thêm người dùng',
    addUserTitle: 'Thêm người dùng cho khách hàng',
    addUserDescription: 'Người dùng đăng nhập vào tài khoản khách hàng. Người dùng mới nhận mật khẩu đầu tiên chỉ hiển thị một lần; bắt buộc bật xác thực hai lớp khi đăng nhập lần đầu.',
    userEmail: 'E-mail đăng nhập',
    userName: 'Họ tên',
    relation: 'Vai trò trong tài khoản',
    create: 'Thêm người dùng',
    created: 'Đã tạo người dùng và gắn vào khách hàng.',
    linked: 'Đã gắn người dùng khách hàng có sẵn vào tài khoản này (không tạo mật khẩu mới).',
    alreadyShown: 'Mật khẩu đầu tiên đã được hiển thị ở lần gửi trước và không thể xem lại.',
    initialPassword: 'Mật khẩu đầu tiên',
    initialPasswordHint: 'Gửi cho người dùng qua kênh an toàn; họ phải đổi mật khẩu và bật xác thực hai lớp khi đăng nhập.',
    loading: 'Đang tải thông tin khách hàng…',
  },
  walletAdjust: {
    action: 'Điều chỉnh số dư',
    title: 'Điều chỉnh số dư ví',
    description: 'Cộng hoặc trừ tiền trong ví của {{customer}} bằng tay, ví dụ khi đã nhận chuyển khoản ngân hàng. Ghi sổ cái đối ứng tài khoản treo thu thủ công và ghi nhật ký kiểm toán cùng lý do.',
    current: 'Số dư {{balance}} · tạm giữ {{held}} · khả dụng {{available}}',
    noWallet: 'Khách hàng chưa có ví: lần cộng tiền đầu tiên sẽ mở ví bằng {{currency}}.',
    direction: 'Loại điều chỉnh',
    credit: 'Cộng tiền',
    debit: 'Trừ tiền',
    amount: 'Số tiền ({{currency}})',
    amountHint: 'Lớn hơn 0; có thể gõ dấu phân cách hàng nghìn (1.000.000).',
    amountInvalid: 'Nhập số tiền lớn hơn 0, đúng đơn vị {{currency}}.',
    amountHintMinor: 'Lớn hơn 0; phần lẻ sau dấu chấm, tối đa {{digits}} chữ số; có thể gõ dấu phẩy phân cách hàng nghìn ({{example}}).',
    amountInvalidMinor: 'Nhập số tiền {{currency}} lớn hơn 0, phần lẻ tối đa {{digits}} chữ số sau dấu chấm (ví dụ {{example}}).',
    amountTooLarge: 'Số tiền quá lớn: sổ cái chỉ ghi được tối đa 14 chữ số phần nguyên (dưới 100.000 tỷ).',
    debitLimit: 'Chỉ trừ được tối đa {{available}}: số dư khả dụng (số dư trừ tiền tạm giữ).',
    reference: 'Mã giao dịch',
    referenceHint: 'Bắt buộc: mã giao dịch trên sao kê ngân hàng hoặc chứng từ thu tiền, để đối chiếu.',
    large: 'Trên {{threshold}} (hoặc bằng ngoại tệ) cần người thứ hai phê duyệt trước.',
    requested: 'Đã gửi đề nghị phê duyệt. Khi người khác phê duyệt (mục Phê duyệt), hãy ghi lại điều chỉnh với đúng số tiền và mã giao dịch này.',
    ordersFunded_one: 'Đã trả {{count}} đơn hàng đang chờ tiền từ ví.',
    ordersFunded_other: 'Đã trả {{count}} đơn hàng đang chờ tiền từ ví.',
    confirmCredit: 'Tôi xác nhận cộng {{amount}} vào ví của {{customer}}.',
    confirmDebit: 'Tôi xác nhận trừ {{amount}} khỏi ví của {{customer}}.',
    submit: 'Ghi điều chỉnh',
    done: 'Đã ghi sổ. Ví hiện có {{balance}}, khả dụng {{available}}.',
    openEntry: 'Mở bút toán',
  },
  newCustomer: {
    button: 'Thêm khách hàng',
    title: 'Thêm khách hàng',
    description: 'Khách hàng là tài khoản mua và thanh toán cùng chủ thể chính (người đứng tên tài khoản). Thông tin định danh nhập một lần, ở chủ thể; khách hàng có thể thêm chủ thể khác.',
    currency: 'Tiền tệ thanh toán',
    cancel: 'Huỷ',
    create: 'Tạo khách hàng',
    createLogin: 'Tạo tài khoản đăng nhập cho khách',
    createLoginHint: 'Người dùng chủ tài khoản với e-mail {{email}}; mật khẩu đầu tiên chỉ hiển thị một lần. Nếu e-mail đã là người dùng của khách hàng khác thì gắn người dùng đó vào.',
    created: 'Đã tạo khách hàng.',
    duplicatesTitle: 'Khách hàng khác đang dùng thông tin trùng',
    duplicateField: { email: 'Trùng e-mail', tax_code: 'Trùng mã số thuế' },
    loginLinked: 'Đã gắn người dùng có sẵn với e-mail này làm chủ tài khoản (không tạo mật khẩu mới).',
    subjectCreated: 'Đã tạo chủ thể chính, chưa xác minh',
    subjectVerify: 'Xác minh chủ thể trước khi đăng ký tên miền.',
    openSubject: 'Mở chủ thể',
    openRepresentative: 'Mở chủ thể người đại diện',
    primarySubject: 'Chủ thể chính',
    primarySubjectHint: 'Người hoặc tổ chức đứng tên tài khoản: cùng các trường và cách kiểm tra như "Thêm chủ thể". E-mail và điện thoại để trống thì dùng của tài khoản.',
    openCustomer: 'Mở khách hàng',
  },
  customerForm: {
    section: {
      account: 'Tài khoản',
      invoice: 'Xuất hoá đơn',
      login: 'Tài khoản đăng nhập',
    },
    email: 'E-mail',
    phone: 'Điện thoại',
    phoneHintVn: 'VD 0912 345 678 hoặc 028 3822 1234; lưu dạng +84…',
    phoneHint: 'Kèm mã quốc gia, VD +65 6123 4567',
    language: 'Ngôn ngữ thông báo',
    languages: { vi: 'Tiếng Việt', en: 'Tiếng Anh' },
    tier: 'Hạng giá',
    province: 'Tỉnh / thành phố',
    ward: 'Phường / xã',
    provinceFirst: 'Chọn tỉnh/thành trước',
    line1: 'Địa chỉ dòng 1',
    line2: 'Địa chỉ dòng 2',
    choose: '— Chọn —',
    loading: 'Đang tải…',
    invoiceSame: 'Giống chủ thể chính',
    invoiceBuyer: 'Tên người mua',
    invoiceTaxCode: 'Mã số thuế',
    invoiceAddress: 'Địa chỉ trên hoá đơn',
    invoiceEmails: 'E-mail nhận hoá đơn',
    invoiceEmailsHint: 'Cách nhau bằng dấu phẩy; tối đa 5 (đã nhập {{count}}).',
    invoiceTaxCodePersonHint: 'Của cá nhân / hộ kinh doanh: số CCCD (của chủ hộ), 12 chữ số.',
    invoiceTaxCodeOrgHint: '10 chữ số, hoặc 10-3 với chi nhánh.',
    duplicate: 'Đang được dùng bởi:',
    fixFields: '{{count}} trường cần sửa.',
    errors: {
      REQUIRED: 'Bắt buộc',
      EMAIL_FORMAT: 'E-mail không hợp lệ',
      PHONE_FORMAT: 'Số điện thoại không hợp lệ (nước ngoài: bắt đầu bằng + và mã quốc gia)',
      COUNTRY_FORMAT: 'Chọn quốc gia',
      LANGUAGE_UNKNOWN: 'Tiếng Việt hoặc tiếng Anh',
      TAX_CODE_FORMAT: 'Mã số thuế doanh nghiệp / tổ chức gồm 10 chữ số, hoặc 10-3 chữ số với chi nhánh (VD 0312345678-001)',
      TAX_CODE_CCCD_FORMAT: 'Mã số thuế của cá nhân / hộ kinh doanh là số CCCD (của chủ hộ), gồm đúng 12 chữ số',
      TAX_CODE_ANY_FORMAT: 'Mã số thuế: 10 hoặc 10-3 chữ số (doanh nghiệp), hoặc số CCCD 12 chữ số (cá nhân, hộ kinh doanh)',
      TAX_CODE_NOT_OWNER_CCCD: 'Phải là số CCCD của chủ hộ',
      HOUSEHOLD_CODE_FORMAT: 'Từ 6 đến 20 chữ cái, chữ số hoặc dấu gạch ngang',
      BUSINESS_KIND_UNKNOWN: 'Doanh nghiệp hoặc hộ kinh doanh',
      CCCD_GENDER_MISMATCH: 'Số CCCD không khớp giới tính',
      CCCD_BIRTH_YEAR_MISMATCH: 'Số CCCD không khớp năm sinh',
      BIRTH_DATE_INVALID: 'Ngày sinh không hợp lệ',
      TOO_YOUNG: 'Người đại diện phải từ 18 tuổi',
      CCCD_FORMAT: 'CCCD gồm 12 chữ số',
      IDENTITY_FORMAT: 'Từ 6 đến 20 chữ cái hoặc chữ số',
      PROVINCE_UNKNOWN: 'Không có trong danh sách VNNIC',
      WARD_UNKNOWN: 'Không có trong danh sách VNNIC',
      WARD_NOT_IN_PROVINCE: 'Phường/xã không thuộc tỉnh/thành đã chọn',
      PLACE_RETIRED: 'Đã bị loại khỏi danh sách VNNIC',
      POSTAL_CODE_FORMAT: 'Mã bưu chính không đúng dạng (Việt Nam: 5 chữ số, mã cũ 6 chữ số)',
      STREET_REQUIRED: 'Bắt buộc',
      TOO_MANY: 'Quá nhiều',
      TIER_UNKNOWN: 'Chọn một hạng giá đang có',
      CURRENCY_UNKNOWN: 'Tiền tệ không hợp lệ',
      NOT_FOUND: 'Không tìm thấy',
      INVALID_VALUE: 'Giá trị không hợp lệ, chọn hoặc nhập lại',
    },
  },
  taxLookup: {
    button: 'Tra cứu',
    running: 'Đang tra cứu…',
    title: 'Thông tin trong cơ sở dữ liệu đăng ký kinh doanh',
    close: 'Đóng',
    name: 'Tên đăng ký',
    shortName: 'Tên viết tắt',
    status: 'Tình trạng',
    foundedOn: 'Ngày thành lập',
    registeredOn: 'Ngày đăng ký',
    representative: 'Người đại diện theo pháp luật',
    owner: 'Chủ hộ kinh doanh',
    nameMatches: '✓ trùng với họ tên đã nhập',
    nameDiffers: 'khác với họ tên đã nhập — kiểm tra lại',
    address: 'Địa chỉ đăng ký',
    addressNote: 'theo danh mục hành chính cũ; nhập địa chỉ theo danh mục hiện hành',
    notActive: 'Doanh nghiệp không ở trạng thái đang hoạt động: không dùng được để đăng ký tên miền.',
    use: 'Dùng tên đăng ký',
    useHint: 'Điền tên đăng ký (và tên viết tắt, ngày thành lập). Họ tên người đại diện nhập theo giấy tờ.',
    notFound: 'Không tìm thấy mã số thuế này trong cơ sở dữ liệu đăng ký kinh doanh.',
    notConnected: 'Máy chủ này chưa kết nối cơ sở dữ liệu đăng ký kinh doanh (Cấu hình tích hợp → VNNIC).',
    forbidden: 'Bạn chưa có quyền tra cứu đăng ký kinh doanh.',
    badCode: 'Mã số thuế không đúng dạng.',
    failed: 'Không tra cứu được lúc này. Thử lại sau.',
    verification: 'Tra cứu đăng ký kinh doanh',
    verificationDone: 'Đã lưu kết quả tra cứu vào bằng chứng xác minh: {{found}}, tên {{name}}.',
    verificationFound: 'có trong cơ sở dữ liệu',
    verificationNotFound: 'không tìm thấy',
    verificationNameMatches: 'trùng',
    verificationNameDiffers: 'không trùng',
    verificationNameUnknown: 'không rõ',
  },
  subjectForm: {
    firstName: 'Tên',
    lastName: 'Họ',
    fullNamePreview: 'Họ và tên: {{name}} — phải trùng tên trên CCCD / hộ chiếu.',
    namesHint: 'Nhập đúng như trên giấy tờ: Họ (ví dụ Nguyễn) và Tên (ví dụ Văn An).',
    contactPerson: 'Người liên hệ của tổ chức',
    contactPersonHint: 'Người liên hệ (thường là người đại diện theo pháp luật): Họ và Tên tách riêng.',
    reverifyNotice: 'Đổi họ, tên, số giấy tờ hoặc ngày sinh cần xác minh lại bằng eKYC trước khi đăng ký tên miền.',
    keepVerificationNotice: 'Họ tên, giấy tờ và ngày sinh không đổi: kết quả định danh hiện có được giữ cho phiên bản mới.',
    keepDeclarationNotice: 'Tên, mã số, địa chỉ, điện thoại, email, người đại diện / chủ hộ không đổi: bản khai chủ thể đã ký (nếu có) vẫn áp dụng cho phiên bản mới.',
    resignDeclarationNotice: 'Đổi tên, mã số, địa chỉ, điện thoại, email hoặc người đại diện / chủ hộ cần ký lại bản khai chủ thể trước khi đăng ký tên miền mới.',
    createTitle: 'Thêm chủ thể',
    editTitle: 'Sửa chủ thể',
    createButton: 'Thêm chủ thể',
    editButton: 'Sửa',
    description: 'Đủ các trường cần để đăng ký tên miền, như nhau cho mọi tên miền. Địa chỉ Việt Nam: chọn tỉnh/thành và phường/xã theo danh mục hành chính.',
    kind: 'Loại chủ thể',
    kinds: { INDIVIDUAL: 'Cá nhân', ORGANIZATION: 'Tổ chức' },
    customerSearch: 'Tìm khách hàng',
    customerSearchPlaceholder: 'Tên hoặc e-mail',
    customer: 'Khách hàng quản lý',
    choose: '— Chọn —',
    loading: 'Đang tải…',
    person: 'Cá nhân',
    organization: 'Tổ chức',
    fullName: 'Họ và tên (theo CCCD)',
    orgName: 'Tên đăng ký',
    tradeName: 'Tên giao dịch / viết tắt',
    establishDate: 'Ngày thành lập',
    birthDate: 'Ngày sinh',
    gender: 'Giới tính',
    genders: { Male: 'Nam', Female: 'Nữ' },
    nationality: 'Quốc tịch (2 chữ)',
    position: 'Chức vụ',
    contactPosition: 'Chức vụ người đại diện',
    identity: 'Giấy tờ định danh',
    idType: 'Loại giấy tờ',
    idTypes: { NATIONAL_ID: 'Căn cước công dân (CCCD)', PASSPORT: 'Hộ chiếu', TAX_CODE: 'Mã số thuế', ENTERPRISE_CODE: 'Mã số doanh nghiệp' },
    idValue: 'Số',
    idIssuedAt: 'Ngày cấp',
    cccdHint: '12 chữ số; phải khớp giới tính và năm sinh.',
    idKept: 'Đang lưu: {{hint}}. Để trống để giữ nguyên.',
    keptOnFile: 'Đã có ngày sinh. Để trống để giữ nguyên.',
    address: 'Địa chỉ',
    country: 'Quốc gia (2 chữ)',
    postalCode: 'Mã bưu chính',
    postalCodeHint: 'Việt Nam: 5 chữ số (mã bưu chính quốc gia); để trống thì dùng 76000.',
    postalCodeVn: 'Mã bưu chính (không bắt buộc, mặc định {{code}})',
    orgKind: 'Loại tổ chức',
    orgKinds: { ENTERPRISE: 'Doanh nghiệp / tổ chức', HOUSEHOLD_BUSINESS: 'Hộ kinh doanh' },
    owner: 'Chủ hộ kinh doanh',
    householdCode: 'Mã số đăng ký hộ kinh doanh',
    householdTaxCode: 'Mã số thuế hộ kinh doanh',
    householdTaxCodeHint: 'Là số CCCD của chủ hộ; để trống thì dùng số CCCD ở trên.',
    representativeOwnerHint: 'Chủ hộ nhập ở trên được tạo thành chủ thể cá nhân và gắn làm người đại diện.',
    street: 'Số nhà, đường',
    streetHint: 'Chỉ phần dưới cấp phường/xã; phường/xã và tỉnh/thành lấy theo danh sách.',
    province: 'Tỉnh / thành phố',
    ward: 'Phường / xã',
    wardCount: '{{count}} phường/xã trong tỉnh/thành này',
    provinceFirst: 'Chọn tỉnh/thành trước',
    city: 'Thành phố',
    state: 'Bang / vùng',
    contact: 'Liên hệ',
    email: 'E-mail',
    phone: 'Điện thoại',
    phoneHint: 'VD 0912 345 678; lưu dạng +84.912345678',
    fax: 'Fax',
    representative: 'Người đại diện theo pháp luật',
    representativeHint: 'Tổ chức cần người đại diện theo pháp luật là một chủ thể cá nhân riêng (liên hệ quản lý của tên miền).',
    representativeCurrent: 'Hiện tại: {{name}}',
    representativeNone: 'Chưa gắn người đại diện',
    representativeModes: { keep: 'Giữ nguyên', existing: 'Chọn chủ thể cá nhân của khách hàng này', new: 'Nhập người đại diện mới', owner: 'Chủ hộ là người đại diện' },
    representativePick: 'Chủ thể cá nhân',
    representativeCustomerFirst: 'Chọn khách hàng quản lý trước',
    representativeSameAddress: 'Cùng địa chỉ tổ chức',
    cccdTaxHint: '12 chữ số; phải khớp giới tính và năm sinh. Số CCCD của cá nhân cũng là mã số thuế.',
    taxCodeHint: '10 chữ số, hoặc 10-3 với chi nhánh (nhập 13 chữ số sẽ lưu dạng 10-3).',
    reason: 'Lý do thay đổi',
    reasonPlaceholder: 'VD khách hàng cập nhật địa chỉ',
    fixFields: '{{count}} trường cần sửa.',
    cancel: 'Huỷ',
    create: 'Tạo chủ thể',
    saveVersion: 'Lưu phiên bản mới',
    errors: {
      REQUIRED: 'Bắt buộc',
      CCCD_FORMAT: 'CCCD gồm 12 chữ số',
      CCCD_GENDER_MISMATCH: 'Số CCCD không khớp giới tính',
      CCCD_BIRTH_YEAR_MISMATCH: 'Số CCCD không khớp năm sinh',
      TAX_CODE_FORMAT: 'Mã số thuế doanh nghiệp / tổ chức gồm 10 chữ số, hoặc 10-3 chữ số với chi nhánh',
      TAX_CODE_CCCD_FORMAT: 'Mã số thuế của cá nhân / hộ kinh doanh là số CCCD (của chủ hộ), gồm đúng 12 chữ số',
      TAX_CODE_NOT_OWNER_CCCD: 'Phải là số CCCD của chủ hộ',
      REPRESENTATIVE_NOT_ALLOWED: 'Chọn một chủ thể cá nhân của cùng khách hàng',
      PASSPORT_FORMAT: 'Từ 6 đến 20 ký tự',
      IDENTIFIER_TYPE_NOT_ALLOWED: 'Không dùng cho loại chủ thể này',
      EMAIL_FORMAT: 'E-mail không hợp lệ',
      PHONE_FORMAT: 'Số điện thoại không hợp lệ',
      BIRTH_DATE_INVALID: 'Ngày sinh không hợp lệ',
      ESTABLISH_DATE_INVALID: 'Ngày thành lập không hợp lệ',
      TOO_YOUNG: 'Chưa đủ tuổi',
      PROVINCE_UNKNOWN: 'Không có trong danh sách VNNIC',
      WARD_UNKNOWN: 'Không có trong danh sách VNNIC',
      WARD_NOT_IN_PROVINCE: 'Phường/xã không thuộc tỉnh/thành đã chọn',
      PLACE_RETIRED: 'Đã bị loại khỏi danh sách VNNIC',
      POSTAL_CODE_FORMAT: 'Mã bưu chính không đúng dạng (Việt Nam: 5 chữ số, mã cũ 6 chữ số)',
      STREET_REQUIRED: 'Bắt buộc',
      HOUSEHOLD_CODE_FORMAT: 'Từ 6 đến 20 chữ cái, chữ số hoặc dấu gạch ngang',
      NOT_FOUND: 'Không tìm thấy',
      INVALID_VALUE: 'Giá trị không hợp lệ, chọn hoặc nhập lại',
    },
  },
  dossiers: {
    title: 'Hồ sơ',
    subtitle: 'Hồ sơ đăng ký của từng tên miền. Hồ sơ đã hoàn tất được khoá; mọi chỉnh sửa sẽ tạo phiên bản mới.',
    domainFilter: 'Tên miền bắt đầu bằng',
    domainPlaceholder: 'example',
    includeSuperseded: 'Gồm cả bản đã thay thế',
    loadError: 'Không tải được danh sách hồ sơ',
    empty: 'Không có hồ sơ phù hợp',
    notBound: 'Chưa gắn',
    views: 'Danh sách hồ sơ theo nhóm',
    view: { ALL: 'Tất cả', SIGNED: 'Đã ký số', NOT_SIGNED: 'Chưa ký số', EKYC: 'Danh sách eKYC', SENSITIVE_KEYWORD: 'Tên miền chứa từ khoá nhạy cảm', NOT_SYNCED: 'Chưa đồng bộ', VNNIC: 'Hồ sơ VNNIC' },
    createEkyc: 'Tạo eKYC',
    createEkycHint: 'Hồ sơ xác thực bằng eKYC đang chờ khách hàng: nhắc khách hàng làm eKYC',
    signed: 'NĐK đã ký',
    notSigned: 'NĐK chưa ký',
    onVnnic: 'Đã gửi VNNIC',
    notSynced: 'Chưa đồng bộ',
    col: { domain: 'Tên miền', version: 'Phiên bản', type: 'Loại', status: 'Trạng thái', registrant: 'Chủ thể', customer: 'Khách hàng', documents: 'Giấy tờ', vnnic: 'VNNIC', completed: 'Hoàn tất', updated: 'Cập nhật' },
  },
  dossier: {
    title: 'Hồ sơ · {{domain}}',
    fallbackTitle: 'Hồ sơ',
    loading: 'Đang tải hồ sơ…',
    notFound: 'Không tìm thấy hồ sơ',
    loadError: 'Không tải được hồ sơ',
    supersededTitle: 'Phiên bản đã bị thay thế',
    superseded: 'Phiên bản này đã được thay thế bởi <link>phiên bản {{n}}</link>.',
    section: 'Hồ sơ',
    frozen: 'đã khoá',
    field: {
      domain: 'Tên miền',
      lifecycle: 'Vòng đời tên miền',
      customer: 'Khách hàng',
      policy: 'Chính sách',
      supersedes: 'Thay thế cho',
      verified: 'Xác minh lúc',
      completed: 'Hoàn tất lúc',
    },
    registrant: 'Chủ thể đăng ký',
    noSubject: 'Chưa gắn chủ thể.',
    verificationProvider: { DKKD: 'Cổng thông tin đăng ký doanh nghiệp quốc gia', VNEID: 'VNeID' },
    registrantField: {
      subject: 'Chủ thể',
      pinnedVersion: 'Phiên bản chủ thể được dùng',
      verification: 'Xác minh',
      method: 'Phương thức xác minh',
      provider: 'Đối chiếu với',
      reviewer: 'Người duyệt',
      expires: 'Xác minh hết hạn',
    },
    tab: { documents: 'Giấy tờ ({{count}})', form: 'Tờ khai và đồng ý', history: 'Lịch sử trạng thái', versions: 'Tất cả phiên bản ({{count}})' },
    noDocuments: 'Chưa gắn giấy tờ nào',
    docCol: { purpose: 'Mục đích', document: 'Giấy tờ', classification: 'Mức phân loại', version: 'Phiên bản', verification: 'Kiểm tra', expires: 'Hết hạn', bound: 'Gắn lúc' },
    formFields: 'Các trường tờ khai đã thu thập',
    consents: 'Xác nhận đồng ý',
    consentFallback: 'Đồng ý',
    consentMeta: 'văn bản {{version}} · {{actor}} · {{at}}',
    noConsents: 'Chưa ghi nhận',
    formNote: 'Giá trị các trường có thể chứa dữ liệu cá nhân nên không hiển thị ở đây; chỉ liệt kê tên trường.',
    noHistory: 'Chưa ghi nhận thay đổi trạng thái',
    // What a dossier still misses (a status change's missing items; lib/missingItem.ts names the other kinds).
    missingItem: {
      subject: 'Chủ thể của hồ sơ',
      identity_verification: 'Xác minh danh tính chủ thể',
      manual_review: 'Nhân viên duyệt hồ sơ',
      // `document:evidence`: the dossier holds no document yet
      evidence: 'Giấy tờ của hồ sơ (chưa có giấy tờ nào)',
    },
    historyCol: { when: 'Thời điểm', from: 'Từ', to: 'Sang', missing: 'Còn thiếu', reason: 'Lý do', actor: 'Người thực hiện' },
    versionCol: { version: 'Phiên bản', status: 'Trạng thái', created: 'Ngày tạo', completed: 'Hoàn tất' },
    thisVersion: 'v{{n}} (bản này)',
    formField: {
      operation: 'Thao tác',
      registrant_address: 'Địa chỉ chủ thể',
      registrant_email: 'E-mail chủ thể',
      registrant_name: 'Tên chủ thể',
      registrant_phone: 'Điện thoại chủ thể',
    },
  },
  documents: {
    title: 'Giấy tờ',
    subtitle: 'Giấy tờ định danh và giấy tờ đăng ký lưu cho chủ thể, hồ sơ và tài khoản, kèm kết quả kiểm tra.',
    owner: 'Thuộc về',
    documentType: 'Loại giấy tờ',
    classification: 'Mức phân loại',
    loadError: 'Không tải được danh sách giấy tờ',
    empty: 'Không có giấy tờ phù hợp',
    versionOf: 'v{{n}} / {{total}}',
    col: { document: 'Giấy tờ', owner: 'Thuộc về', classification: 'Mức phân loại', current: 'Phiên bản hiện hành', verification: 'Kiểm tra', expires: 'Hết hạn', dossiers: 'Hồ sơ', uploaded: 'Tải lên' },
  },
  document: {
    fallbackTitle: 'Giấy tờ',
    loading: 'Đang tải giấy tờ…',
    notFound: 'Không tìm thấy giấy tờ',
    loadError: 'Không tải được giấy tờ',
    section: 'Giấy tờ',
    field: { type: 'Loại', classification: 'Mức phân loại', owner: 'Thuộc về', versions: 'Số phiên bản', created: 'Ngày tạo' },
    encryptedTitle: 'Tệp được lưu mã hoá',
    encrypted: 'Mở một giấy tờ để xem hoặc tải tệp về: cần quyền xem giấy tờ định danh, mỗi lần mở được ghi nhật ký kèm lý do.',
    view: 'Xem',
    download: 'Tải về',
    readTitle: 'Mở tệp {{name}}',
    readBody: 'Lần mở tệp lưu trữ được ghi nhật ký kèm lý do và cần quyền xem giấy tờ định danh.',
    previewHint: 'Tệp lưu trữ, được giải mã để xem.',
    tab: { versions: 'Phiên bản ({{count}})', bindings: 'Dùng trong hồ sơ ({{count}})' },
    noVersions: 'Chưa có phiên bản',
    current: 'hiện hành',
    by: 'bởi {{actor}}',
    score: 'điểm {{score}}',
    reviewedBy: 'duyệt bởi {{name}}',
    versionCol: { version: 'Phiên bản', file: 'Tệp', sha: 'SHA-256', issued: 'Ngày cấp', expires: 'Hết hạn', uploaded: 'Tải lên', verifications: 'Kết quả kiểm tra' },
    noBindings: 'Chưa được dùng trong hồ sơ nào',
    bindingCol: { domain: 'Tên miền', dossier: 'Hồ sơ', purpose: 'Mục đích', version: 'Phiên bản giấy tờ', bound: 'Gắn lúc' },
  },
  enum: {
    customerStatus: { ACTIVE: 'Đang hoạt động', SUSPENDED: 'Tạm ngưng', CLOSED: 'Đã đóng' },
    subjectStatus: { ACTIVE: 'Đang hoạt động', MERGED: 'Đã gộp', DEACTIVATED: 'Ngừng sử dụng' },
    verification: { UNVERIFIED: 'Chưa xác minh', PENDING: 'Đang chờ', VERIFIED: 'Đã xác minh', FAILED: 'Thất bại', MISMATCH: 'Không khớp', EXPIRED: 'Hết hạn', REVOKED: 'Đã thu hồi' },
    docVerification: { PENDING: 'Đang chờ', PASSED: 'Đạt', FAILED: 'Không đạt', INCONCLUSIVE: 'Chưa kết luận' },
    classification: { PUBLIC: 'Công khai', INTERNAL: 'Nội bộ', CONFIDENTIAL: 'Bảo mật', HIGHLY_SENSITIVE: 'Rất nhạy cảm', SECRET: 'Tuyệt mật' },
    dossierStatus: {
      NOT_CREATED: 'Chưa tạo',
      COLLECTING: 'Đang thu thập',
      PENDING_IDENTITY: 'Chờ định danh',
      PENDING_DOCUMENT: 'Chờ giấy tờ',
      PENDING_SIGNATURE: 'Chờ ký',
      PENDING_REVIEW: 'Chờ duyệt',
      COMPLETE: 'Hoàn tất',
      INVALID: 'Không hợp lệ',
      EXPIRED: 'Hết hạn',
      CORRECTION_REQUIRED: 'Cần bổ sung, chỉnh sửa',
      SUPERSEDED: 'Đã thay thế',
    },
    accountType: { INDIVIDUAL: 'Cá nhân', ORGANIZATION: 'Tổ chức' },
    subjectType: { INDIVIDUAL: 'Cá nhân', ORGANIZATION: 'Tổ chức', HOUSEHOLD_BUSINESS: 'Hộ kinh doanh', GOVERNMENT_ENTITY: 'Cơ quan nhà nước', FOREIGN_ENTITY: 'Tổ chức nước ngoài', OTHER: 'Khác' },
    dossierType: { VN_DOMAIN: 'Tên miền .vn', INTERNATIONAL_GTLD: 'Tên miền quốc tế gTLD', INTERNATIONAL_NEW_GTLD: 'Tên miền quốc tế new gTLD', INTERNATIONAL_CCTLD: 'Tên miền quốc tế ccTLD', OTHER: 'Khác' },
    ownerType: { SUBJECT: 'Chủ thể', DOSSIER: 'Hồ sơ', CUSTOMER: 'Khách hàng', CASE: 'Vụ việc lạm dụng' },
    userKind: { STAFF: 'Nhân viên', CLIENT: 'Khách hàng', CUSTOMER: 'Khách hàng' },
    relation: { OWNER: 'Chủ tài khoản', ADMIN: 'Quản trị', BILLING: 'Thanh toán', TECHNICAL: 'Kỹ thuật', READ_ONLY: 'Chỉ xem' },
    userStatus: { ACTIVE: 'Đang hoạt động', INVITED: 'Đã mời', SUSPENDED: 'Tạm ngưng', DISABLED: 'Vô hiệu hoá', LOCKED: 'Bị khoá' },
    role: {
      customer: 'Khách hàng',
      support: 'Chăm sóc khách hàng',
      billing: 'Nghiệp vụ thanh toán',
      compliance: 'Cán bộ tuân thủ',
      registry_ops: 'Vận hành registry',
      security: 'An ninh',
      administrator: 'Quản trị hệ thống',
      auditor: 'Kiểm toán (chỉ xem)',
      ops_viewer: 'Theo dõi vận hành',
      ops_engineer: 'Kỹ sư vận hành',
      ops_admin: 'Quản trị vận hành',
    },
    scopeType: { GLOBAL: 'Toàn hệ thống', CUSTOMER: 'Khách hàng' },
    documentType: {
      NATIONAL_ID_CARD: 'Căn cước công dân',
      PASSPORT: 'Hộ chiếu',
      BUSINESS_REGISTRATION_CERTIFICATE: 'Giấy chứng nhận đăng ký doanh nghiệp',
      REGISTRATION_DECLARATION: 'Bản khai đăng ký tên miền',
      AUTHORIZATION_LETTER: 'Giấy uỷ quyền',
      OTHER: 'Khác',
      REGISTRAR_SIGNED_FILE: 'Tệp NĐK đã ký',
      REGISTRAR_SIGNED_DECLARATION: 'Bản khai NĐK đã ký',
      SIGNED_DECLARATION: 'Bản khai đã ký',
      SIGNED_SUBJECT_DECLARATION: 'Bản khai thông tin chủ thể đã ký',
      NATIONAL_ID_SCAN: 'Bản chụp giấy tờ tuỳ thân',
      BUSINESS_REGISTRATION: 'Giấy phép ĐKKD',
      EKYC_ID_CARD_FRONT: 'Ảnh eKYC mặt trước giấy tờ',
      EKYC_ID_CARD_BACK: 'Ảnh eKYC mặt sau giấy tờ',
      EKYC_SELFIE: 'Ảnh chân dung eKYC',
      REGISTRATION_FORM: 'Bản khai tên miền',
      DOMAIN_DECLARATION: 'Bản khai tên miền',
      TRANSFEREE_DECLARATION: 'Bản khai của bên nhận chuyển nhượng',
      NEW_HOLDER_DECLARATION: 'Bản khai của chủ thể mới',
      IDENTITY_CARD_FRONT: 'CCCD mặt trước',
      IDENTITY_CARD_BACK: 'CCCD mặt sau',
      REGISTRAR_CHANGE_FORM: 'Bản khai chuyển đổi nhà đăng ký',
      CHANGE_INFORMATION_REQUEST: 'Đơn đề nghị thay đổi thông tin tên miền',
      SENSITIVE_KEYWORD_COMMITMENT: 'Cam kết tên miền chứa từ khoá nhạy cảm',
      RETURN_REQUEST: 'Đơn đề nghị hoàn trả tên miền',
      RETURN_REQUEST_FORM: 'Đơn đề nghị hoàn trả tên miền (mẫu)',
      GOV_VN_COMMITMENT: 'Biên bản giải trình và cam kết gov.vn',
      LOOKING_DOMAIN_FORM: 'Bản khai dịch vụ looking domain',
      NAME_VN_EXPLANATION: 'Bản giải trình đăng ký .name.vn',
      SIGNED_ORGANIZATION_INFO: 'Bản khai thông tin tổ chức đã ký',
      REGISTRANT_NAME_CHANGE_REQUEST: 'Đơn đề nghị thay đổi tên chủ thể',
      NAME_CHANGE_DECISION: 'Quyết định đổi tên',
      TRANSFER_TAX_COMMITMENT: 'Cam kết nghĩa vụ thuế chuyển nhượng',
      TRANSFER_TAX_RECEIPT: 'Chứng từ nộp thuế chuyển nhượng',
      TRANSFER_AGREEMENT: 'Văn bản đề nghị chuyển nhượng tên miền',
      TRANSFER_APPROVAL: 'Văn bản chấp thuận chuyển nhượng tên miền',
      DOMAIN_CERTIFICATE: 'Giấy chứng nhận tên miền',
      SERVICE_CONTRACT: 'Hợp đồng cung cấp dịch vụ tên miền',
      ORGANIZATION_INFO: 'Hồ sơ doanh nghiệp (bản khai thông tin tổ chức)',
    },
    purpose: {
      IDENTITY_DOCUMENT: 'Giấy tờ định danh',
      IDENTITY_PROOF: 'Chứng minh định danh',
      REGISTRATION_DECLARATION: 'Bản khai đăng ký',
      ADDRESS_PROOF: 'Xác nhận địa chỉ',
      AUTHORIZATION: 'Uỷ quyền',
      OTHER: 'Khác',
      REGISTRAR_SIGNED_FILE: 'Tệp NĐK đã ký',
      REGISTRAR_SIGNED_DECLARATION: 'Bản khai NĐK đã ký',
      SIGNED_DECLARATION: 'Bản khai đã ký',
      SIGNED_SUBJECT_DECLARATION: 'Bản khai thông tin chủ thể đã ký',
      NATIONAL_ID_SCAN: 'Bản chụp giấy tờ tuỳ thân',
      BUSINESS_REGISTRATION: 'Giấy phép ĐKKD',
      EKYC_ID_CARD_FRONT: 'Ảnh eKYC mặt trước giấy tờ',
      EKYC_ID_CARD_BACK: 'Ảnh eKYC mặt sau giấy tờ',
      EKYC_SELFIE: 'Ảnh chân dung eKYC',
      REGISTRATION_FORM: 'Bản khai tên miền',
      DOMAIN_DECLARATION: 'Bản khai tên miền',
      TRANSFEREE_DECLARATION: 'Bản khai của bên nhận chuyển nhượng',
      NEW_HOLDER_DECLARATION: 'Bản khai của chủ thể mới',
      IDENTITY_CARD_FRONT: 'CCCD mặt trước',
      IDENTITY_CARD_BACK: 'CCCD mặt sau',
      REGISTRAR_CHANGE_FORM: 'Bản khai chuyển đổi nhà đăng ký',
      CHANGE_INFORMATION_REQUEST: 'Đơn đề nghị thay đổi thông tin tên miền',
      SENSITIVE_KEYWORD_COMMITMENT: 'Cam kết tên miền chứa từ khoá nhạy cảm',
      RETURN_REQUEST: 'Đơn đề nghị hoàn trả tên miền',
      RETURN_REQUEST_FORM: 'Đơn đề nghị hoàn trả tên miền (mẫu)',
      GOV_VN_COMMITMENT: 'Biên bản giải trình và cam kết gov.vn',
      LOOKING_DOMAIN_FORM: 'Bản khai dịch vụ looking domain',
      NAME_VN_EXPLANATION: 'Bản giải trình đăng ký .name.vn',
      SIGNED_ORGANIZATION_INFO: 'Bản khai thông tin tổ chức đã ký',
      REGISTRANT_NAME_CHANGE_REQUEST: 'Đơn đề nghị thay đổi tên chủ thể',
      NAME_CHANGE_DECISION: 'Quyết định đổi tên',
      TRANSFER_TAX_COMMITMENT: 'Cam kết nghĩa vụ thuế chuyển nhượng',
      TRANSFER_TAX_RECEIPT: 'Chứng từ nộp thuế chuyển nhượng',
      TRANSFER_AGREEMENT: 'Văn bản đề nghị chuyển nhượng tên miền',
      TRANSFER_APPROVAL: 'Văn bản chấp thuận chuyển nhượng tên miền',
      DOMAIN_CERTIFICATE: 'Giấy chứng nhận tên miền',
      SERVICE_CONTRACT: 'Hợp đồng cung cấp dịch vụ tên miền',
      PASSPORT: 'Hộ chiếu',
    },
    actorType: { CUSTOMER: 'Khách hàng', OPERATOR: 'Nhân viên vận hành', SYSTEM: 'Hệ thống', RESELLER: 'Đại lý', STAFF: 'Nhân viên', USER: 'Người dùng', REGISTRY: 'Registry' },
    verificationType: { OCR: 'OCR', MANUAL: 'Duyệt thủ công', FACE_MATCH: 'Đối chiếu khuôn mặt', REGISTRY_LOOKUP: 'Tra cứu cơ sở dữ liệu', AUTHENTICITY: 'Kiểm tra tính xác thực', SIGNATURE: 'Kiểm tra chữ ký', REGISTRAR_SIGNATURE: 'Chữ ký NĐK', STRUCTURE: 'Kiểm tra cấu trúc tệp' },
    verificationMethod: {
      EKYC_CCCD_CHIP: 'eKYC (CCCD gắn chip)',
      BUSINESS_REGISTRY_LOOKUP: 'Tra cứu đăng ký doanh nghiệp',
      MANUAL_REVIEW: 'Duyệt thủ công (đã bỏ)',
      DOCUMENT_UPLOAD: 'Tải lên giấy tờ',
      DIGITAL_SIGNATURE: 'Chữ ký số',
      ELECTRONIC_IDENTITY: 'Định danh điện tử',
      EKYC: 'eKYC',
      LEGAL_DOCUMENT: 'Giấy tờ pháp lý (đã bỏ)',
    },
    consentType: { REGISTRATION_AGREEMENT: 'Thoả thuận đăng ký', DATA_PROCESSING: 'Xử lý dữ liệu cá nhân', MARKETING: 'Tiếp thị', TERMS_OF_SERVICE: 'Điều khoản dịch vụ' },
  },
};
